"use client";

import createSvgIcon from "./utils/createSvgIcon.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon(/*#__PURE__*/_jsx("path", {
  d: "M20 2h2v20h-2zM2 10h16V7H2zm6 7h10v-3H8z"
}), 'AlignHorizontalRightTwoTone');